import PasswordHasBeenSet from './PasswordHasBeenSet';

export default PasswordHasBeenSet;
